import deepmerge from 'deepmerge';
import deAT from './de-AT.json';
import deAtDefault from '../default/de-AT.json';
var messages = {
    'de-AT': deepmerge(deAtDefault, deAT),
};
export default messages;
//# sourceMappingURL=index.js.map